// src/SubscriptionStatus.ts
var UserSubscriptionStatus = /* @__PURE__ */ ((UserSubscriptionStatus2) => {
  UserSubscriptionStatus2["INCOMPLETE"] = "INCOMPLETE";
  UserSubscriptionStatus2["TRIALING"] = "TRIALING";
  UserSubscriptionStatus2["ACTIVE"] = "ACTIVE";
  UserSubscriptionStatus2["PAST_DUE"] = "PAST_DUE";
  UserSubscriptionStatus2["CANCELED"] = "CANCELED";
  UserSubscriptionStatus2["UNPAID"] = "UNPAID";
  return UserSubscriptionStatus2;
})(UserSubscriptionStatus || {});

// src/UserMetadataFlags.ts
var UserMetadataFlags = /* @__PURE__ */ ((UserMetadataFlags2) => {
  UserMetadataFlags2["GETTING_STARTED_MODAL_DISMISSED"] = "GETTING_STARTED_MODAL_DISMISSED";
  UserMetadataFlags2["LEAVE_REVIEW_MESSAGE_DISMISSED"] = "LEAVE_REVIEW_MESSAGE_DISMISSED";
  UserMetadataFlags2["ONBOARDING_DISMISSED_OR_COMPLETED"] = "ONBOARDING_DISMISSED_OR_COMPLETED";
  return UserMetadataFlags2;
})(UserMetadataFlags || {});

// src/APIDebugFlags.ts
var SHORT_TTL_FLAG = 1;
var SHORT_REFRESH_TTL_FLAG = 16;
var APIDebugFlags = Object.freeze({
  SHORT_TTL_FLAG,
  SHORT_REFRESH_TTL_FLAG
});

// src/HandshakeCodeOrigin.ts
var HandshakeCodeOrigin = /* @__PURE__ */ ((HandshakeCodeOrigin2) => {
  HandshakeCodeOrigin2["UNKNOWN"] = "UNKNOWN";
  HandshakeCodeOrigin2["PLUGIN"] = "PLUGIN";
  HandshakeCodeOrigin2["STANDALONE"] = "STANDALONE";
  return HandshakeCodeOrigin2;
})(HandshakeCodeOrigin || {});

// src/SubscriptionPlanType.ts
var SubscriptionPlanType = /* @__PURE__ */ ((SubscriptionPlanType2) => {
  SubscriptionPlanType2["Free"] = "FREE";
  SubscriptionPlanType2["Standard"] = "STANDARD";
  SubscriptionPlanType2["Professional"] = "PROFESSIONAL";
  SubscriptionPlanType2["Enterprise"] = "ENTERPRISE";
  return SubscriptionPlanType2;
})(SubscriptionPlanType || {});

// src/SubscriptionPlanConfig.ts
var SubscriptionPlanConfig = Object.freeze({
  ["FREE" /* Free */]: {
    type: "FREE" /* Free */,
    features: {
      versioningDays: 0,
      renderPriority: "low",
      gifQuality: "720p",
      variables: false,
      flexibleAnchorPoint: false,
      premiumProperties: false
    },
    limits: {
      numberOfVersionsPerAnimation: 1,
      numberOfUsersPerPlan: 1
    }
  },
  ["STANDARD" /* Standard */]: {
    type: "STANDARD" /* Standard */,
    features: {
      versioningDays: 7,
      renderPriority: "low",
      gifQuality: "720p",
      variables: true,
      flexibleAnchorPoint: true,
      premiumProperties: false
    },
    limits: {
      numberOfVersionsPerAnimation: 5,
      numberOfUsersPerPlan: 1
    }
  },
  ["PROFESSIONAL" /* Professional */]: {
    type: "PROFESSIONAL" /* Professional */,
    features: {
      versioningDays: 30,
      renderPriority: "medium",
      gifQuality: "1440p",
      variables: true,
      flexibleAnchorPoint: true,
      premiumProperties: true
    },
    limits: {
      numberOfVersionsPerAnimation: 15,
      numberOfUsersPerPlan: 3
    }
  },
  ["ENTERPRISE" /* Enterprise */]: {
    type: "ENTERPRISE" /* Enterprise */,
    features: {
      versioningDays: 365,
      renderPriority: "high",
      gifQuality: "1440p",
      variables: true,
      flexibleAnchorPoint: true,
      premiumProperties: true
    },
    limits: {
      numberOfVersionsPerAnimation: Infinity,
      numberOfUsersPerPlan: Infinity
    }
  }
});

// src/NodeOrigins.ts
var NodeOrigins = /* @__PURE__ */ ((NodeOrigins2) => {
  NodeOrigins2["TOPLEFT"] = "TOPLEFT";
  NodeOrigins2["TOPCENTER"] = "TOPCENTER";
  NodeOrigins2["TOPRIGHT"] = "TOPRIGHT";
  NodeOrigins2["MIDDLELEFT"] = "MIDDLELEFT";
  NodeOrigins2["MIDDLECENTER"] = "MIDDLECENTER";
  NodeOrigins2["MIDDLERIGHT"] = "MIDDLERIGHT";
  NodeOrigins2["BOTTOMLEFT"] = "BOTTOMLEFT";
  NodeOrigins2["BOTTOMCENTER"] = "BOTTOMCENTER";
  NodeOrigins2["BOTTOMRIGHT"] = "BOTTOMRIGHT";
  return NodeOrigins2;
})(NodeOrigins || {});

// src/LayerViewMode.ts
var LayerViewMode = /* @__PURE__ */ ((LayerViewMode2) => {
  LayerViewMode2["ALL"] = "ALL";
  LayerViewMode2["GROUPED"] = "GROUPED";
  return LayerViewMode2;
})(LayerViewMode || {});

// src/AnimationPlayStatus.ts
var AnimationPlayStatus = /* @__PURE__ */ ((AnimationPlayStatus2) => {
  AnimationPlayStatus2["IDLE"] = "IDLE";
  AnimationPlayStatus2["PLAYING"] = "PLAYING";
  AnimationPlayStatus2["ENDED"] = "ENDED";
  return AnimationPlayStatus2;
})(AnimationPlayStatus || {});

// src/AnimationRenderStatus.ts
var AnimationRenderStatus = /* @__PURE__ */ ((AnimationRenderStatus2) => {
  AnimationRenderStatus2["IDLE"] = "IDLE";
  AnimationRenderStatus2["RENDERING"] = "RENDERING";
  AnimationRenderStatus2["PROVISIONING"] = "PROVISIONING";
  AnimationRenderStatus2["PROCESSING"] = "PROCESSING";
  AnimationRenderStatus2["DOWNLOADING"] = "DOWNLOADING";
  AnimationRenderStatus2["FINISHED"] = "FINISHED";
  AnimationRenderStatus2["ERROR"] = "ERROR";
  return AnimationRenderStatus2;
})(AnimationRenderStatus || {});

// src/AnimatableProperties.ts
var AnimatableProperties = /* @__PURE__ */ ((AnimatableProperties2) => {
  AnimatableProperties2["x"] = "x";
  AnimatableProperties2["y"] = "y";
  AnimatableProperties2["width"] = "width";
  AnimatableProperties2["height"] = "height";
  AnimatableProperties2["opacity"] = "opacity";
  AnimatableProperties2["borderRadius"] = "borderRadius";
  AnimatableProperties2["rotation"] = "rotation";
  AnimatableProperties2["itemSpacing"] = "itemSpacing";
  AnimatableProperties2["padding"] = "padding";
  AnimatableProperties2["fillColor"] = "fillColor";
  AnimatableProperties2["letterSpacing"] = "letterSpacing";
  AnimatableProperties2["fontSize"] = "fontSize";
  AnimatableProperties2["textContent"] = "textContent";
  AnimatableProperties2["strokeWidth"] = "strokeWidth";
  AnimatableProperties2["strokeColor"] = "strokeColor";
  AnimatableProperties2["arcData"] = "arcData";
  AnimatableProperties2["vectorPath"] = "vectorPath";
  AnimatableProperties2["effects"] = "effects";
  AnimatableProperties2["visible"] = "visible";
  AnimatableProperties2["componentProperties"] = "componentProperties";
  return AnimatableProperties2;
})(AnimatableProperties || {});

// src/DynamicAnimatableProperties.ts
var DynamicAnimatableProperties = /* @__PURE__ */ ((DynamicAnimatableProperties2) => {
  DynamicAnimatableProperties2["scale"] = "scale";
  DynamicAnimatableProperties2["scaleX"] = "scaleX";
  DynamicAnimatableProperties2["scaleY"] = "scaleY";
  DynamicAnimatableProperties2["translateX"] = "translateX";
  DynamicAnimatableProperties2["translateY"] = "translateY";
  DynamicAnimatableProperties2["followPath"] = "followPath";
  return DynamicAnimatableProperties2;
})(DynamicAnimatableProperties || {});

// src/Easings.ts
var Easings = /* @__PURE__ */ ((Easings2) => {
  Easings2["easeIn"] = "easeIn";
  Easings2["easeOut"] = "easeOut";
  Easings2["easeInOut"] = "easeInOut";
  Easings2["easeInQuad"] = "easeInQuad";
  Easings2["easeOutQuad"] = "easeOutQuad";
  Easings2["easeInOutQuad"] = "easeInOutQuad";
  Easings2["easeInCubic"] = "easeInCubic";
  Easings2["easeOutCubic"] = "easeOutCubic";
  Easings2["easeInOutCubic"] = "easeInOutCubic";
  Easings2["easeInQuart"] = "easeInQuart";
  Easings2["easeOutQuart"] = "easeOutQuart";
  Easings2["easeInOutQuart"] = "easeInOutQuart";
  Easings2["easeInQuint"] = "easeInQuint";
  Easings2["easeOutQuint"] = "easeOutQuint";
  Easings2["easeInOutQuint"] = "easeInOutQuint";
  Easings2["easeInExpo"] = "easeInExpo";
  Easings2["easeOutExpo"] = "easeOutExpo";
  Easings2["easeInOutExpo"] = "easeInOutExpo";
  Easings2["easeInCirc"] = "easeInCirc";
  Easings2["easeOutCirc"] = "easeOutCirc";
  Easings2["easeInOutCirc"] = "easeInOutCirc";
  Easings2["easeInBack"] = "easeInBack";
  Easings2["easeOutBack"] = "easeOutBack";
  Easings2["easeInOutBack"] = "easeInOutBack";
  Easings2["linear"] = "linear";
  Easings2["custom"] = "custom";
  return Easings2;
})(Easings || {});

// src/FigmaBlendModes.ts
var FigmaBlendModes = /* @__PURE__ */ ((FigmaBlendModes2) => {
  FigmaBlendModes2["PASS_THROUGH"] = "PASS_THROUGH";
  FigmaBlendModes2["NORMAL"] = "NORMAL";
  FigmaBlendModes2["DARKEN"] = "DARKEN";
  FigmaBlendModes2["MULTIPLY"] = "MULTIPLY";
  FigmaBlendModes2["LINEAR_BURN"] = "LINEAR_BURN";
  FigmaBlendModes2["COLOR_BURN"] = "COLOR_BURN";
  FigmaBlendModes2["LIGHTEN"] = "LIGHTEN";
  FigmaBlendModes2["SCREEN"] = "SCREEN";
  FigmaBlendModes2["LINEAR_DODGE"] = "LINEAR_DODGE";
  FigmaBlendModes2["COLOR_DODGE"] = "COLOR_DODGE";
  FigmaBlendModes2["OVERLAY"] = "OVERLAY";
  FigmaBlendModes2["SOFT_LIGHT"] = "SOFT_LIGHT";
  FigmaBlendModes2["HARD_LIGHT"] = "HARD_LIGHT";
  FigmaBlendModes2["DIFFERENCE"] = "DIFFERENCE";
  FigmaBlendModes2["EXCLUSION"] = "EXCLUSION";
  FigmaBlendModes2["HUE"] = "HUE";
  FigmaBlendModes2["SATURATION"] = "SATURATION";
  FigmaBlendModes2["COLOR"] = "COLOR";
  FigmaBlendModes2["LUMINOSITY"] = "LUMINOSITY";
  return FigmaBlendModes2;
})(FigmaBlendModes || {});

// src/FigmaEffectTypes.ts
var FigmaEffectTypes = /* @__PURE__ */ ((FigmaEffectTypes2) => {
  FigmaEffectTypes2["DROP_SHADOW"] = "DROP_SHADOW";
  FigmaEffectTypes2["INNER_SHADOW"] = "INNER_SHADOW";
  FigmaEffectTypes2["LAYER_BLUR"] = "LAYER_BLUR";
  FigmaEffectTypes2["BACKGROUND_BLUR"] = "BACKGROUND_BLUR";
  return FigmaEffectTypes2;
})(FigmaEffectTypes || {});

// src/FollowPathMode.ts
var FollowPathMode = /* @__PURE__ */ ((FollowPathMode2) => {
  FollowPathMode2["START_AT"] = "start_at";
  FollowPathMode2["END_AT"] = "end_at";
  return FollowPathMode2;
})(FollowPathMode || {});

// src/RenderFormat.ts
var RenderFormat = /* @__PURE__ */ ((RenderFormat2) => {
  RenderFormat2["MP4"] = "mp4";
  RenderFormat2["GIF"] = "gif";
  RenderFormat2["WEBM"] = "webm";
  RenderFormat2["WEBP"] = "webp";
  RenderFormat2["PNG"] = "png";
  return RenderFormat2;
})(RenderFormat || {});

// src/ResetMode.ts
var ResetMode = /* @__PURE__ */ ((ResetMode2) => {
  ResetMode2["START"] = "start";
  ResetMode2["END"] = "end";
  return ResetMode2;
})(ResetMode || {});

// src/WindingRule.ts
var WindingRule = /* @__PURE__ */ ((WindingRule2) => {
  WindingRule2["NONE"] = "NONE";
  WindingRule2["NONZERO"] = "NONZERO";
  WindingRule2["EVENODD"] = "EVENODD";
  return WindingRule2;
})(WindingRule || {});

// src/UserRole.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["OWNER"] = "OWNER";
  UserRole2["EDITOR"] = "EDITOR";
  return UserRole2;
})(UserRole || {});

// src/SubscriptionPlanTypeSortValues.ts
var SubscriptionPlanTypeSortValues = Object.freeze({
  ["FREE" /* Free */]: 0,
  ["STANDARD" /* Standard */]: 10,
  ["PROFESSIONAL" /* Professional */]: 20,
  ["ENTERPRISE" /* Enterprise */]: 30
});

// src/RenderPriorityValues.ts
var RenderPriorityValues = Object.freeze({
  low: 10,
  medium: 20,
  high: 30
});
export {
  APIDebugFlags,
  AnimatableProperties,
  AnimationPlayStatus,
  AnimationRenderStatus,
  DynamicAnimatableProperties,
  Easings,
  FigmaBlendModes,
  FigmaEffectTypes,
  FollowPathMode,
  HandshakeCodeOrigin,
  LayerViewMode,
  NodeOrigins,
  RenderFormat,
  RenderPriorityValues,
  ResetMode,
  SubscriptionPlanConfig,
  SubscriptionPlanType,
  SubscriptionPlanTypeSortValues,
  UserMetadataFlags,
  UserRole,
  UserSubscriptionStatus,
  WindingRule
};
